import React, { useEffect, useState } from 'react'
import { FieldTypes } from '../../utils/constants'
import Form from '../common/Form'
import useBroadcastGroupsApi from '../../hooks/broadcastGroups/useBroadcastGroupsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import ListHeader from '../common/ListHeader'
import useStyles from '../common/FormFields/FormFieldsStyle'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'

export default function BroadcastGroupForm({
  isSecurityUser,
  goBack,
  buildingId,
}) {
  const classes = useStyles()
  const [values, setValues] = useState({ name: '', apartments: [] })
  const [broadcastGroup, setBroadcastGroup] = useState(null)
  const [{ getApartmentsFromBuildingState }, apartmentsMethods] =
    useApartmentsApi()
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()

  const apartments = getApartmentsFromBuildingState.apartments

  const [
    { broadcastGroupsState },
    { getBroadcastGroups, createBroadcastGroup, updateBroadcastGroup },
  ] = useBroadcastGroupsApi()

  useEffect(() => {
    const fetchBroadcastGroupsData = async () => {
      getBroadcastGroups()
      getBuildings()
      if (buildingId) {
        apartmentsMethods.getApartmentsFromBuilding(buildingId)
      }
    }
    fetchBroadcastGroupsData()
  }, [])

  const handleSubmit = () => {
    const data = {
      name: values.name,
      apartments: values.apartments.map((apartment) => apartment.id),
    }
    if (broadcastGroup) {
      updateBroadcastGroup(broadcastGroup.id, data)
    } else {
      createBroadcastGroup(data)
    }
    goBack()
  }
  console.log(buildingId)
  return (
    <div className={classes.paper}>
      <ListHeader bigTitle="Grupos de difusión" canCreate={false} />
      <Form
        values={values}
        setValues={setValues}
        fields={[
          {
            type: FieldTypes.Autocomplete,
            label:
              'Si desea editar un grupo de difusión existente, seleccionelo en el siguiente campo',
            hint: 'Seleccione un grupo de difusión',
            key: 'broadcastGroup',
            options: broadcastGroupsState.broadcastGroups.data || [],
            multiple: false,
            freeSolo: false,
            withMargin: true,
            onChange: (value) => {
              if (value) {
                setBroadcastGroup(value)
                setValues({ name: value.name, apartments: value.apartments })
              } else {
                setBroadcastGroup(null)
                setValues({ name: '', apartments: [] })
              }
            },
            value: broadcastGroup,
          },
          {
            type: FieldTypes.TextField,
            label: 'Nombre',
            hint: 'Ingrese un nombre',
            key: 'name',
            errorMessage: 'El nombre es requerido',
            withMargin: true,
          },
          ...(!buildingId
            ? [
                {
                  type: FieldTypes.Autocomplete,
                  label: 'Cliente asociado',
                  hint: 'Seleccione un cliente',
                  key: 'buildingId',
                  options: buildingsState.buildings,
                  multiple: false,
                  freeSolo: false,
                  withMargin: true,
                  onChange: (value) => {
                    apartmentsMethods.getApartmentsFromBuilding(value.id)
                  },
                  errorMessage: 'El cliente es requerido',
                },
              ]
            : []),
          {
            type: FieldTypes.Autocomplete,
            label: 'Unidad',
            hint: 'Seleccione al menos una unidad',
            key: 'apartments',
            options: apartments || [],
            multiple: true,
            freeSolo: false,
            withMargin: true,
            renderTags: () => null,
            disabled: apartments.length === 0,
            onChange: (value) => {
              const selectedOption = value[value.length - 1]
              if (
                !values.apartments.find(
                  (apartment) => apartment.id === selectedOption.id
                )
              ) {
                setValues({ ...values, apartments: value })
              }
            },
            errorMessage: 'Debe seleccionar al menos un apartamento',
          },
          {
            type: FieldTypes.Chips,
            items: values.apartments || [],
            getLabel: (item) =>
              isSecurityUser
                ? `${item.name}`
                : `${item.building.name} - ${item.name}`,
            key: 'apartments',
            isSecurityUser: isSecurityUser,
            onDelete: (i) => {
              const apartments = values.apartments.slice()
              apartments.splice(i, 1)
              setValues({ ...values, apartments })
            },
          },
        ]}
        handleSubmit={handleSubmit}
        handleCancel={goBack}
      />
    </div>
  )
}
